import { useEffect, useState, useRef } from 'react';
export function useProgressAnimation(_ref) {
  let {
    isLoading,
    totalCount = 20,
    progressUpdateInterval = 100,
    countUpdateInterval = 200,
    progressIncrement = 2,
    countIncrement = 1,
    statusMessageCount = 1,
    onAnimationComplete
  } = _ref;
  const [progress, setProgress] = useState(0);
  const [count, setCount] = useState(0);
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  const [statusMessageIndex, setStatusMessageIndex] = useState(0);
  const progressIntervalRef = useRef(null);
  const countIntervalRef = useRef(null);
  const hasStartedRef = useRef(false);
  useEffect(() => {
    if (isLoading && !hasStartedRef.current) {
      hasStartedRef.current = true;
      setProgress(0);
      setCount(0);
      setIsAnimationComplete(false);
      setStatusMessageIndex(0);
    }
    if (!isLoading && !hasStartedRef.current) {
      return;
    }
    if (!progressIntervalRef.current) {
      progressIntervalRef.current = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            if (progressIntervalRef.current) {
              clearInterval(progressIntervalRef.current);
              progressIntervalRef.current = null;
            }
            return 100;
          }
          return Math.min(100, prev + progressIncrement);
        });
      }, progressUpdateInterval);
    }
    if (!countIntervalRef.current) {
      countIntervalRef.current = setInterval(() => {
        setCount(prev => {
          if (prev >= totalCount) {
            if (countIntervalRef.current) {
              clearInterval(countIntervalRef.current);
              countIntervalRef.current = null;
            }
            return totalCount;
          }
          return Math.min(totalCount, prev + countIncrement);
        });
      }, countUpdateInterval);
    }
    return () => {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = null;
      }
      if (countIntervalRef.current) {
        clearInterval(countIntervalRef.current);
        countIntervalRef.current = null;
      }
    };
  }, [isLoading, totalCount, progressUpdateInterval, countUpdateInterval, progressIncrement, countIncrement]);
  useEffect(() => {
    if (progress >= 100 && count >= totalCount && !isAnimationComplete) {
      setIsAnimationComplete(true);
    }
  }, [progress, count, totalCount, isAnimationComplete]);
  useEffect(() => {
    if (statusMessageCount > 1 && hasStartedRef.current) {
      const segmentSize = 100 / statusMessageCount;
      const newIndex = Math.min(statusMessageCount - 1, Math.floor(progress / segmentSize));
      setStatusMessageIndex(newIndex);
    }
  }, [progress, statusMessageCount]);
  useEffect(() => {
    if (isAnimationComplete && onAnimationComplete) {
      onAnimationComplete();
    }
  }, [isAnimationComplete, onAnimationComplete]);
  return {
    progress,
    count,
    isAnimationComplete,
    statusMessageIndex
  };
}
//# sourceMappingURL=useProgressAnimation.js.map